export const ASSETS = {
  song: "https://customer-assets.emergentagent.com/job_freedom-serenity/artifacts/zdwl627n_WhatsApp%20Audio%202026-06-21%20at%2016.00.08.mpeg.mp3",
  logo: "https://customer-assets.emergentagent.com/job_freedom-serenity/artifacts/k3ume5wy_WhatsApp%20Image%202026-06-21%20at%2016.00.36.jpeg",
  talicia: "https://customer-assets.emergentagent.com/job_freedom-serenity/artifacts/46sqipj6_WhatsApp%20Image%202026-06-21%20at%2016.05.02.jpeg",
  sandra: "https://customer-assets.emergentagent.com/job_freedom-serenity/artifacts/ehmfax6a_WhatsApp%20Image%202026-06-21%20at%2015.53.12.jpeg",
  hero: "https://customer-assets.emergentagent.com/job_freedom-serenity/artifacts/gh88snxh_WhatsApp%20Image%202026-06-21%20at%2017.19.55.jpeg",
  liefdesbloem: "https://static.prod-images.emergentagent.com/jobs/2f7e1ced-3e7c-4abc-bb8a-6ade67e7c4ce/images/61cdc612e836332bcf286cbf0adbc48657223731051a1641df63469a18e914f7.jpeg",
};

export const PILLARS = [
  { icon: "Leaf", title: "Zachtheid", sub: "in alles wat we doen" },
  { icon: "Flower2", title: "Rust", sub: "voor lichaam en geest" },
  { icon: "Heart", title: "Verbinding", sub: "met jezelf en het leven" },
  { icon: "Sun", title: "Bewustwording", sub: "van binnenuit" },
];

export const SESSIONS = [
  {
    id: "boom",
    name: "De Boom",
    icon: "TreeDeciduous",
    image: "https://static.prod-images.emergentagent.com/jobs/2f7e1ced-3e7c-4abc-bb8a-6ade67e7c4ce/images/64d26536e667e774b18ac4282a120fca624c9a95d281769dc467c98b11aaeedf.png",
    short:
      "De boom staat voor veiligheid, groei en verbinding. De wortels dragen je terwijl je leert voelen zonder jezelf te verliezen.",
    long:
      "In de sessie van De Boom keren we terug naar je basis. We werken met ademhaling en lichaamsbewustzijn om je te laten ervaren hoe het is om geworteld en gedragen te zijn. Net als een boom mag je groeien in je eigen tempo, stevig verbonden met de grond onder je voeten en open naar het licht.",
  },
  {
    id: "rots",
    name: "De Rots",
    icon: "Mountain",
    image: "https://static.prod-images.emergentagent.com/jobs/2f7e1ced-3e7c-4abc-bb8a-6ade67e7c4ce/images/e13463e30599abdcdacac7eb2c0f67680fabd787dc143ba3260ef88f76ac28e5.png",
    short:
      "De rots symboliseert innerlijke kracht en stabiliteit. Hier leer je stevig aanwezig te blijven bij emoties en spanning.",
    long:
      "De Rots leert je standvastigheid. Wanneer emoties als golven tegen je aan slaan, mag je leren staan als een rots: aanwezig, kalm en onverstoorbaar. Door visualisatie en verankering ontdek je dat je niet meegesleurd hoeft te worden door wat er in je leeft. Je kracht zit van binnen.",
  },
  {
    id: "meertje",
    name: "Het Meertje",
    icon: "Waves",
    image: "https://static.prod-images.emergentagent.com/jobs/2f7e1ced-3e7c-4abc-bb8a-6ade67e7c4ce/images/0c033b6d1ea48c6880ff7b3d98af32f082661148a294e7354bb7cfc3f098d8e3.png",
    short:
      "Het meertje brengt verstilling. Zoals water emoties draagt zonder oordeel, leer jij ruimte maken voor wat gevoeld wil worden.",
    long:
      "Bij Het Meertje vertragen we. Water beweegt zacht en draagt alles zonder oordeel. In deze sessie leer je ruimte maken voor wat er gevoeld wil worden, zonder het weg te duwen. Door stilte, zang en zachte oefeningen ontstaat er rust, helderheid en een diep gevoel van verstilling.",
  },
  {
    id: "vuur",
    name: "Het Vuur",
    icon: "Flame",
    image: "https://static.prod-images.emergentagent.com/jobs/2f7e1ced-3e7c-4abc-bb8a-6ade67e7c4ce/images/2fa59cec2e670388d146839b717c71fef16d97e88929a0582aed2440f24b7bbd.png",
    short:
      "Het vuur staat voor transformatie. Oude spanning mag verzachten zodat energie opnieuw vrij kan stromen.",
    long:
      "Het Vuur is de sessie van transformatie. Oude spanning, vastgehouden emoties en overlevingspatronen mogen verzachten en oplossen. Door beweging, adem en intentie maken we ruimte voor nieuwe, vrije energie. Wat niet langer dient, mag los — zodat je opnieuw warmte en levenslust kunt voelen.",
  },
  {
    id: "liefdesbloem",
    name: "De Liefdesbloem",
    icon: "Flower2",
    image: "https://static.prod-images.emergentagent.com/jobs/2f7e1ced-3e7c-4abc-bb8a-6ade67e7c4ce/images/61cdc612e836332bcf286cbf0adbc48657223731051a1641df63469a18e914f7.jpeg",
    short:
      "De Liefdesbloem staat symbool voor liefde, zachtheid, vertrouwen en verbinding. Je maakt opnieuw contact met de liefde die al in jou aanwezig is.",
    long:
      "Midden in Freedom bloeit een bijzondere bloem: de Liefdesbloem. Deze bloem staat symbool voor liefde, zachtheid, vertrouwen en verbinding. Tijdens deze verankersessie neem je de tijd om stil te staan bij jezelf en opnieuw contact te maken met de liefde die al in jou aanwezig is.",
  },
];

export const WERKWIJZE_PIJLERS = [
  "Ademhaling", "Visualisatie", "Lichaamsbewustzijn", "Verankering",
  "Stilte", "Verhalen", "Zang & muziek", "Oefeningen",
];

export const FEATURES = [
  {
    icon: "Brain",
    title: "Het kinderbrein & volwassen brein",
    text: "Wanneer gevoel en bewustzijn samenwerken, ontstaat veiligheid en ruimte om te worden. Lees meer over deze unieke samenwerking.",
    anchor: "#brein",
  },
  {
    icon: "BookOpen",
    title: "Verhalen & visualisaties",
    text: "Verhalen creëren herkenning zonder dat alles benoemd hoeft te worden. Visualisaties nemen je mee naar innerlijke plekken van rust, kracht en heling.",
    anchor: "#werkwijze",
  },
  {
    icon: "Music",
    title: "Muziek & zang",
    text: "Zachte klanken helpen het lichaam ontspannen en brengen emoties op een natuurlijke manier in beweging. Muziek raakt dieper dan woorden.",
    anchor: "#muziek",
  },
  {
    icon: "Wind",
    title: "Oefeningen",
    text: "Bewust ademen, spanning herkennen, het lichaam voelen, emoties observeren en vriendelijker worden voor jezelf.",
    anchor: "#werkwijze",
  },
];

export const PRICING = [
  {
    name: "Freedom Workshop 1",
    price: "€ 120",
    unit: "per workshop",
    duration: "± 2,5 uur",
    desc: "De introductieworkshop waarin je kennismaakt met ademhaling, visualisatie en lichaamsbewustzijn. Een eerste stap van het hoofd naar het gevoel.",
    featured: false,
  },
  {
    name: "Verankeringssessies",
    price: "€ 80",
    unit: "per sessie",
    duration: "± 1,5 uur",
    desc: "Eén van de vijf verankersessies — De Boom, De Rots, Het Meertje, Het Vuur of De Liefdesbloem. Verdiepend werk rond veiligheid, kracht, verstilling, transformatie en liefde.",
    featured: true,
  },
  {
    name: "Freedom Verdiepingsworkshop",
    price: "€ 210",
    unit: "Workshop 2",
    duration: "± 2,5 uur",
    desc: "De verdiepende workshop voor wie verder wil gaan. We bouwen voort op de basis en verankeren rust, verbinding en vrijheid nog dieper.",
    featured: false,
  },
];

export const INTRO =
  "Wij begeleiden je op een liefdevolle en respectvolle manier naar meer verbinding met jezelf. Samen creëren we ruimte voor rust, groei en herstel, zodat jij vanuit vertrouwen, liefde en kracht verder kunt gaan.";

export const WELCOME = {
  title: "Welkom bij Freedom Serenity",
  intro:
    "Vanaf 1 september biedt Freedom Serenity twee bijzondere sessies aan die gericht zijn op rust, inzicht, persoonlijke groei en innerlijke kracht. Onze sessies helpen je om opnieuw in verbinding te komen met jezelf. Ze kunnen ondersteuning bieden na een ingrijpende gebeurtenis, bij stress, een burn-out, een trauma of andere moeilijke situaties.",
  extra:
    "Maar Freedom Serenity is er niet alleen voor mensen die vastlopen. Ook wanneer je sterker wilt worden, meer in je kracht wilt staan of bewustere keuzes in het leven wilt maken, ben je van harte welkom.",
  begeleidingTitle: "Persoonlijke begeleiding",
  begeleiding: [
    "Bij Freedom Serenity luisteren we aandachtig naar jouw verhaal. Van jouw verhaal maken wij een vergelijkbaar of compleet ander verhaal, dat tijdens de sessie op een liefdevolle en veilige manier wordt gebruikt. Dit helpt je om inzicht te krijgen in wat er in jouw leven speelt en om situaties vanuit een ander perspectief te bekijken.",
    "Daarnaast ontvang je praktische handvatten en oefeningen die je kunnen helpen om op een andere manier met moeilijke situaties om te gaan. Zo kan er meer rust ontstaan in lichaam en geest en ontstaat er ruimte voor herstel, groei en innerlijke kracht.",
    "De begeleiding is zowel individueel als in groepsverband mogelijk. Wanneer meerdere mensen met dezelfde situatie of uitdaging te maken hebben, kan een groepssessie een waardevolle manier zijn om elkaar te ondersteunen en samen te groeien.",
  ],
};

export const SESSIES = [
  {
    id: "verhaal",
    label: "Sessie 1",
    name: "Freedom Verhaal Sessie",
    icon: "BookOpen",
    duration: "gemiddeld 1 uur",
    price: "€ 60",
    available: "vanaf 1 september",
    text:
      "In de Freedom Verhaal Sessie luisteren we aandachtig naar jouw verhaal. Op een liefdevolle en veilige manier verweven we dit tot een verhaal dat je helpt inzicht te krijgen in wat er speelt en situaties vanuit een nieuw perspectief te bekijken. Je ontvangt praktische handvatten en oefeningen voor meer rust in lichaam en geest.",
  },
  {
    id: "reis",
    label: "Sessie 2",
    name: "De Reis naar Binnen",
    icon: "Compass",
    duration: "ongeveer een half uur",
    price: "€ 40",
    available: "vanaf 1 september",
    text:
      "Tijdens Sessie 2 maak je een innerlijke reis naar jezelf. Op een rustige en veilige manier word je begeleid door visualisaties, ademhaling, voelen, zachte beweging en waar passend muziek of zang. Je maakt kennis met de vijf verankerpunten van Freedom Serenity — De Boom, De Rots, Het Meertje, Het Vuur en De Liefdesbloem — die je steeds opnieuw terugbrengen naar rust, vertrouwen en liefde. Veel mensen ervaren deze reis als een moment van diepe ontspanning, helderheid en thuiskomen bij zichzelf.",
  },
];

export const CONTACT = {
  phone: "+31 6 42678380",
  phoneHref: "tel:+31642678380",
  email: "praktijkfreedom@gmail.com",
  location: "Gevestigd in Nederland",
};
